import _ from "lodash";
import axios from "axios";
import { canaveral_url } from ".";

export const fetchRestaurantsList = async (params) => {
  try {
    const response = await axios.get(
      `${canaveral_url}/restaurants/opentable/`,
      {
        params: { ...params },
      }
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const retrieveRestaurant = async ({ rid }) => {
  try {
    const response = await axios.get(
      `${canaveral_url}/restaurants/opentable/${rid}`
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const fetchRestaurantCategories = async (params) => {
  try {
    const response = await axios.get(
      `${canaveral_url}/restaurants/opentable/categories`
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};
